import React from 'react';
import episode1 from '../asset/episode1.png';
import episode2 from '../asset/episode2.png';
import episode3 from '../asset/episode3.png';
import episode4 from '../asset/episode4.png';
import previewIcon from '../asset/previewIcon.png';
import { Link } from 'react-router-dom';

const titlesKo = [
  "1화. 새로운 세상, 영재학교 입학의 문",
  "2화. 인공수재와 자연수재",
  "3화. 나방",
  "4화. 압록강의 노래"
];

const titlesEn = [
  "Ep 1. the door to admission to gifted schools",
  "Ep 2. Artificial Genius and Natural Genius",
  "Ep 3. Moth",
  "Ep 4. Song of the Amnok River"
];

const Content = ({ language }) => {
  const titles = language === 'ko' ? titlesKo : titlesEn;

  return (
    <>
      <div className="preview-header">
        <img src={previewIcon} alt="Preview Icon" className="preview-icon" />
        <h4>Preview</h4>
      </div>
      <div className="content">
        <Link to={`/pdf-viewer?lang=${language}&index=0`} style={{textDecoration:'none'}}>
          <div className="episode">
            <img src={episode1} alt="Episode 1" />
            <div className="episode-title">{titles[0]}</div>
          </div>
        </Link>
        <Link to={`/pdf-viewer?lang=${language}&index=1`} style={{textDecoration:'none'}}>
          <div className="episode">
            <img src={episode2} alt="Episode 2" />
            <div className="episode-title">{titles[1]}</div>
          </div>
        </Link>
        <Link to={`/pdf-viewer?lang=${language}&index=2`} style={{textDecoration:'none'}}>
          <div className="episode">
            <img src={episode3} alt="Episode 3" />
            <div className="episode-title">{titles[2]}</div>
          </div>
        </Link>
        <Link to={`/pdf-viewer?lang=${language}&index=3`} style={{textDecoration:'none'}}>
          <div className="episode last-episode">
            <img src={episode4} alt="Episode 4" />
            <div className="episode-title">{titles[3]}</div>
          </div>
        </Link>
      </div>
    </>
  );
}

export default Content;
